import React, {useEffect, useState} from 'react';
import OverviewAPI from "../../api/OverviewAPI";
import {useDispatch, useSelector} from "react-redux";
import InitiatePopup from "../Overview/InitiatePopup";
import {setFlag} from "../../features/responseSlice";

function CloseBalance({availableBalances}) {
    const [initiateModal, setInitiateModal] = useState(false);

    const {flag} = useSelector((state) => state.transferResponse);

    const dispatch = useDispatch();

    const handleInitiateTransferToLegal = async (e) => {
        await InitiateTransferToLegal();
        if(initiateTransfer && availableBalances[0]?.AvailableBalance > 0 || availableBalances[1]?.AvailableBalance > 0)
            setInitiateModal(true);
    }

    const {
        InitiateTransferToLegal,
        initiateTransfer,
        setInitiateTransfer
    } = OverviewAPI();

    useEffect(() => {
        if (initiateTransfer) {
            setInitiateModal(true);
        }
    }, [initiateTransfer]);

    useEffect(() => {
        if ([0, 1].includes(flag)) {
            setInitiateTransfer(null);
            dispatch(setFlag(null));
            setInitiateTransfer(null);
        }
        setInitiateModal(false);
    }, [flag]);


    return (
        <>
            {sessionStorage.getItem("EntityRole") !== "Supervisor" &&
                <div className="row">
                    <div className="filters">
                        <div className="text">Amount will be automatically transferred to the legal
                            entity end of day. However you can always close the balance manually
                        </div>
                        <div className="btn">
                            <button
                                onClick={handleInitiateTransferToLegal}
                                disabled={availableBalances[0]?.AvailableBalance <= 0 && availableBalances[1]?.AvailableBalance<=0}
                            >Close Balance Manually
                            </button>
                        </div>
                    </div>
                </div>
            }

            <InitiatePopup isOpen={initiateModal} setIsOpen={setInitiateModal} message={initiateTransfer?.Message}
                           account1Value={initiateTransfer?.Balances[0]}
                           account2Value={initiateTransfer?.Balances[1]}
                           InitiateTransferDate={initiateTransfer?.InitiateTransferDate}
            />
        </>
    );
}

export default CloseBalance;